import { useEffect } from 'react';
import { LiaBrainSolid, LiaInfoCircleSolid, LiaRedoAltSolid } from 'react-icons/lia';

import { Button } from '@/components-new/button';
import { Card } from '@/components-new/card';
import { Spinner } from '@/components-new/spinner';
import { useDrugSummaryMutation } from '@/features/ai/api';

type DrugSummaryCardProps = {
  drugId: number;
};

export const DrugSummaryCard = ({ drugId }: DrugSummaryCardProps) => {
  const { mutate, data, isPending, isError, reset } = useDrugSummaryMutation();

  useEffect(() => {
    mutate({ drugId });
  }, [drugId, mutate]);

  const handleRetry = () => {
    reset();
    mutate({ drugId });
  };

  return (
    <Card outlined className="ai-shimmer">
      <div>
        <h3 className="flex items-center gap-2 text-sm font-medium text-gray-900">
          <LiaBrainSolid className="size-5 shrink-0 text-secondary-600" />
          Artia Intelligence Summary
        </h3>

        {isPending && (
          <div className="mt-2 flex items-center gap-2">
            <Spinner className="size-4" />
            <p className="text-sm text-gray-500">Generating Artia Intelligence summary...</p>
          </div>
        )}

        {isError && (
          <div className="mt-2">
            <p className="text-sm text-gray-500">Unable to generate Artia Intelligence summary.</p>
            <Button plain onClick={handleRetry} className="mt-1 text-xs">
              <LiaRedoAltSolid />
              Retry
            </Button>
          </div>
        )}

        {data && (
          <>
            <p className="mt-1 text-sm text-gray-700">{data.summary}</p>
            <p className="mt-3 flex items-center gap-1.5 text-xs text-gray-500">
              <LiaInfoCircleSolid className="size-4 shrink-0" />
              Artia Intelligence can make mistakes. Verify important information.
            </p>
          </>
        )}
      </div>
    </Card>
  );
};
